import { Collection } from 'modules/core/lib/mobx-rest'

import CustomField from 'modules/custom_resources/store/models/customFields/Field'

export interface ModelWithCustomFieldIdentifier {
  customFieldsIdentifier: () => string
}

export class CustomFieldsByGroupCollection extends Collection<CustomField> {
  get cacheKey(): string {
    return 'customFieldsByGroup'
  }

  model() {
    return CustomField
  }

  createForGroup(group: string, data: Record<string, string | number>) {
    return this.create({ ...data, usage_group_slug: [group] })
  }

  byUsageGroup(groups: string[]): Promise<any> {
    return this.fetch({
      data: {
        usage_group_slug: groups,
      },
    })
  }
}

export default new CustomFieldsByGroupCollection()
